// @flow

import type {Schema as MarkdocTagSchema, NodeType} from '@markdoc/markdoc';
import * as registrations from './registrations';
import * as functions from './functions';

const showCollisionWarning = (type: string, name: string) => {
  // eslint-disable-next-line
  console.error(
    `A Markdoc ${type} with the name '${name}' has already been registered. ` +
      `Ensure that you haven't accidentally registered two ${type}s with the same name. ` +
      `If you're seeing this message during hot module replacement, you can safely ignore it.`,
  );
};

const tags: {[name: string]: MarkdocTagSchema} = {};
const nodes: {[name: NodeType]: MarkdocTagSchema} = {};

Object.values(registrations).forEach((registration: any) => {
  if (registration.node) {
    const {node, component, ...schema} = registration;
    if (nodes[node]) {
      showCollisionWarning('node', node);
    }
    nodes[node] = {
      ...schema,
      tag: component,
    };
  } else {
    const {tag, component, ...schema} = registration;
    if (tags[tag]) {
      showCollisionWarning('tag', tag);
    }
    tags[tag] = {
      ...schema,
      tag: component,
    };
  }
});

export default {tags, nodes, functions};
